import { render, staticRenderFns } from "./LocationsManagementIndex.vue?vue&type=template&id=551c652b&"
import script from "./LocationsManagementIndex.vue?vue&type=script&lang=js&"
export * from "./LocationsManagementIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports